import React from 'react'

import { Axes } from '../../common/axes/axes'

export const ForestAxes = function ({ dimensions, labels, xScale }) {
  return (
    <Axes
      scales={{ x: xScale }}
      formatters={{ x: (value) => value.toString(), y: () => '' }}
      labels={labels}
      dimensions={dimensions}
      options={{ hideAxisLeft: true }}
      axisBottomProps={{ hideAxisLine: true }}
    />
  )
}
